import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dff3f9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MicroservicesListItem" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-base font-semibold" }
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "(ID: " + _toDisplayString(_ctx.item.id) + ") " + _toDisplayString(_ctx.item.name), 1),
      _createVNode(_component_cheap, {
        class: _normalizeClass(["small", { green: Boolean(_ctx.item.isActive), red: !Boolean(_ctx.item.isActive) }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(Boolean(_ctx.item.isActive) ? 'Активен' : 'Не активен'), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.item.host || '-'), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_the_button, {
        class: "primary small text mr-2",
        loading: _ctx.state.is_importing || _ctx.isImporting,
        disabled: _ctx.state.is_importing || _ctx.isImporting || !Boolean(_ctx.item.host),
        onClick: _ctx.importRoutes
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Импортировать routes ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary small text",
        onClick: _ctx.emitUpdate
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createTextVNode(" Редактировать ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}